export enum ArgumentsLayoutsEnum {
  DEFAULT = 'DEFAULT',
  DIVIDED = 'DIVIDED',
  EMBEDDED = 'EMBEDDED'
}
